export default __webpack_public_path__ + "static/media/img-stake-wallet-mobile.8bd5b457.png";